import ButtonLink from "@/common/components/ButtonLink";
import ImageWithDisplayName from "@/common/components/ImageWithDisplayName";
import { governmentAllocationEntriesKind } from "@/common/constants/governmentAllocationEntriesKind.constant";
import { formatCurrency, formatDateRange, formatDateTime } from "@/common/utils/formatters";
import { CompanyGovernmentAllocationEntryData } from "@/features/privateCompanies/types/companyGovernmentAllocationEntry.type";
import { ArrowBigRight, BriefcaseBusinessIcon, UserIcon } from "lucide-react";
import { Link } from "react-router-dom";

export class GovermnentAllocationEntriesNotCompletedTransformer {
  static tableTransformer() {
    return (entries: CompanyGovernmentAllocationEntryData[]) => {
      return entries.map((entry) => {
        return {
          ...entry,
          total_value: formatCurrency(Number(entry.total_value) || 0),
          kind: governmentAllocationEntriesKind[entry.kind as keyof typeof governmentAllocationEntriesKind],
          applicable_date: entry.government_allocation && formatDateRange(new Date(`${entry.government_allocation.applicable_start_date} `), new Date(`${entry.government_allocation.applicable_end_date} `)),
          company: (
            <ButtonLink
              linkTo={`/companies/${entry.company?.id}`}
              operationKlassToCheckPermission='Admin::Client::Companies::Show'
            >
              <ImageWithDisplayName
                placeholderIcon={BriefcaseBusinessIcon}
                imageUrl={entry.company.general_information.company_logo?.url}
                displayName={entry.company.general_information.fantasy_name}
              />
            </ButtonLink>
          ),
          company_branch: (
            <ButtonLink
              linkTo={`/companies/${entry.company?.id}/branches/${entry.branch?.id}`}
              operationKlassToCheckPermission='Admin::Client::CompanyBranches::Show'
            >
              <ImageWithDisplayName
                placeholderIcon={BriefcaseBusinessIcon}
                imageUrl={entry.branch.general_information?.company_logo?.url}
                displayName={entry.branch.display_name}
              />
            </ButtonLink>
          ),
          creator: entry.creator && (
            <ButtonLink
              linkTo={`/companies/${entry.company?.id}/users/${entry.creator?.id}`}
              operationKlassToCheckPermission='Admin::Client::Users::Show'
            >
              <ImageWithDisplayName
                placeholderIcon={UserIcon}
                imageUrl={entry.creator?.profile_picture.url}
                displayName={entry.creator.full_name}
              />
            </ButtonLink>
          ),
          created_at: entry.created_at && formatDateTime(new Date(entry.created_at)),
          actions: (
            <>
              <Link to={`/companies/${entry.company.id}/government-allocations/${entry.id}/edit`}>
                <ArrowBigRight />
              </Link>
            </>
          ),
        }
      });
    }
  }
}
